import { useAppSelector } from '@/store/hooks';
import { selectProfile, selectIsProfileLoading } from '@/store/slices/userProfileSlice';

export interface UseCurrentUserRoleResult {
  isAdmin: boolean;
  isLoading: boolean;
}

/**
 * Reads the current user's WebAPI role from the user-profile slice. The role
 * is delivered by `GET /profile` (client mode) and written into the slice by
 * `useUserProfile`, so this hook is now a pure selector — no extra request is
 * made. In agent mode there is no client-mode role, so `isAdmin` is `false`.
 */
export function useCurrentUserRole(): UseCurrentUserRoleResult {
  const profile = useAppSelector(selectProfile);
  const isProfileLoading = useAppSelector(selectIsProfileLoading);

  return {
    isAdmin: profile?.role === 'Admin',
    isLoading: isProfileLoading,
  };
}
